let language = {
    STANDARD_ORDER_PAY_CONFIRM_TIP: "Please confirm your design and shipping address are correct. Once submitted, the order cannot be modified",
    SAMPLE_ORDER_PAY_CONFIRM_TIP: "Please confirm your design and shipping address are correct. Once submitted, the order cannot be modified"
}

export { language }